import React, { useEffect, useState } from "react";
import User from "../Services/userServices";
import { Pie } from "@ant-design/charts";

function Dashboard(props) {
  const [report, setReport] = useState();
  const getReports = () => {
    User.getReports()
      .then((response) => {
        setReport(response.data);
      })
      .catch((error) => {
        console.log("___+ error in reports", error);
      });
  };
  useEffect(() => {
    getReports();
  }, []);

  return (
    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div class="col-lg-3 col-sm-6 col-12">
            <div class="dash-widget">
              <div class="dash-widgetimg">
                <span>
                  <img src="/assets/img/icons/dash1.svg" alt="img" />
                </span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  <span class="counters" data-count={report?.totalShops}>
                    {report?.totalShops}
                  </span>
                </h5>
                <h6>Total Shop</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-12">
            <div class="dash-widget dash1">
              <div class="dash-widgetimg">
                <span>
                  <img src="/assets/img/icons/dash2.svg" alt="img" />
                </span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  <span class="counters" data-count={report?.totalSoldShops}>
                    {report?.totalSoldShops}
                  </span>
                </h5>
                <h6>Total Sold Shops</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-12">
            <div class="dash-widget dash2">
              <div class="dash-widgetimg">
                <span>
                  <img src="/assets/img/icons/dash3.svg" alt="img" />
                </span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  <span class="counters" data-count={report?.totalRentalShops}>
                    {report?.totalRentalShops}
                  </span>
                </h5>
                <h6>Shops on Rent</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-12">
            <div class="dash-widget dash3">
              <div class="dash-widgetimg">
                <span>
                  <img src="/assets/img/icons/dash4.svg" alt="img" />
                </span>
              </div>
              <div class="dash-widgetcontent">
                <h5>
                  <span class="counters" data-count={report?.totalShops}>
                    {report?.totalShops -
                      report?.totalSoldShops -
                      report?.totalRentalShops}
                  </span>
                </h5>
                <h6>Other Shops</h6>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-12 d-flex">
            <div class="dash-count">
              <div class="dash-counts">
                <h4>{report?.totalShopkeepers || 0}</h4>
                <h5>Total Shopkeepers</h5>
              </div>
              <div class="dash-imgs">
                <i data-feather="user"></i>
              </div>
            </div>
          </div>
          {/* <div class="col-lg-3 col-sm-6 col-12 d-flex">
            <div class="dash-count das1">
              <div class="dash-counts">
                <h4>100</h4>
                <h5>Suppliers</h5>
              </div>
              <div class="dash-imgs">
                <i data-feather="user-check"></i>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-12 d-flex">
            <div class="dash-count das2">
              <div class="dash-counts">
                <h4>100</h4>
                <h5>Purchase Invoice</h5>
              </div>
              <div class="dash-imgs">
                <i data-feather="file-text"></i>
              </div>
            </div>
          </div> */}
          <div class="col-lg-3 col-sm-6 col-12 d-flex">
            <div class="dash-count das3">
              <div class="dash-counts">
                <h4>{report?.totalActiveShopkeepers || 0}</h4>
                <h5>Active Shopkeepers</h5>
              </div>
              <div class="dash-imgs">
                <i data-feather="user"></i>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-6 col-12 d-flex">
            <div class="dash-count das2">
              <div class="dash-counts">
                <h4>
                  {report?.totalShopkeepers - report?.totalActiveShopkeepers ||
                    0}
                </h4>
                <h5>Others</h5>
              </div>
              <div class="dash-imgs">
                <i data-feather="user"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6 col-sm-12 col-12 d-flex">
            <div class="card flex-fill">
              <h3>Shops ({report?.totalShops})</h3>
              <Pie
                {...{
                  radius: 0.8,
                  data: [
                    {
                      type: "Free Shops",
                      value:
                        report?.totalShops -
                          report?.totalSoldShops -
                          report?.totalRentalShops || 0,
                    },
                    {
                      type: "Sold Shops",
                      value: report?.totalSoldShops || 0,
                    },
                    {
                      type: "Shops on Rent",
                      value: report?.totalRentalShops || 0,
                    },
                  ],
                  angleField: "value",
                  colorField: "type",
                  label: {
                    visible: true,
                    type: "inner",
                  },
                }}
              />
            </div>
          </div>
          <div class="col-lg-6 col-sm-12 col-12 d-flex">
            <div class="card flex-fill">
              <h3>Shopkeepers ({report?.totalShopkeepers})</h3>
              <Pie
                {...{
                  radius: 0.8,
                  data: [
                    {
                      type: "Total Shopkeeper",
                      value: report?.totalShopkeepers,
                    },
                    {
                      type: "Active Shopkeepers",
                      value: report?.totalActiveShopkeepers,
                    },
                    {
                      type: "Others",
                      value:
                        report?.totalShopkeepers -
                        report?.totalActiveShopkeepers,
                    },
                  ],
                  angleField: "value",
                  colorField: "type",
                  label: {
                    visible: true,
                    type: "inner",
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
